module.exports = __webpack_public_path__ + "static/media/e-Eid-Card.6a0bfb1b.jpg";